import SvgColor from '../../../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

// `badgeKey` is a string marker — Nav/index.js replaces it with a live React node
// before passing the config to NavSection.
const navConfig = [
  {
    subheader: 'Overview',
    items: [
      { title: 'Dashboard', path: '/admin/dashboard/app', icon: icon('ic_analytics') },
    ],
  },
  {
    subheader: 'Users',
    items: [
      { title: 'Users',           path: '/admin/dashboard/user',            icon: icon('ic_user') },
      { title: 'Delete Requests', path: '/admin/dashboard/delete-requests', icon: icon('ic_user') },
    ],
  },
  {
    subheader: 'Subscriptions',
    items: [
      { title: 'Memberships', path: '/admin/dashboard/membership', icon: icon('ic_user')  },
      { title: 'Plans',       path: '/admin/dashboard/plans',      icon: icon('ic_blog')  },
    ],
  },
  {
    subheader: 'Products',
    items: [
      { title: 'All Products',   path: '/admin/dashboard/products-management', icon: icon('ic_cart') },
      { title: 'MSI Category',   path: '/admin/dashboard/category-msi',        icon: icon('ic_cart') },
      { title: 'MSI Products',   path: '/admin/dashboard/product-msi',         icon: icon('ic_cart') },
      { title: 'FIP Products',   path: '/admin/dashboard/product-fip',         icon: icon('ic_cart') },
      { title: 'FIP Categories', path: '/admin/dashboard/category-fip',        icon: icon('ic_cart') },
    ],
  },
  {
    subheader: 'Notifications',
    items: [
      // badgeKey tells Nav/index.js to inject the live unread chip here
      { title: 'Notification Center', path: '/admin/dashboard/notification-center', icon: icon('ic_notification'), badgeKey: 'notificationUnread' },
      { title: 'Dashboard',           path: '/admin/dashboard/notifications/dashboard', icon: icon('ic_analytics') },
      { title: 'Compose',             path: '/admin/dashboard/notifications/compose',   icon: icon('ic_compose')   },
      { title: 'Campaigns',           path: '/admin/dashboard/notifications/campaigns', icon: icon('ic_blog')      },
      { title: 'Scheduled',           path: '/admin/dashboard/notifications/scheduled', icon: icon('ic_schedule')  },
      { title: 'Devices',             path: '/admin/dashboard/notifications/devices',   icon: icon('ic_device')    },
      { title: 'Send Logs',           path: '/admin/dashboard/notifications/logs',      icon: icon('ic_logs')      },
    ],
  },
  {
    subheader: 'Analytics',
    items: [
      { title: 'Search Analytics', path: '/admin/dashboard/search-analytics', icon: icon('ic_analytics') },
    ],
  },
  {
    subheader: 'Settings',
    items: [
      { title: 'Change Password', path: '/admin/dashboard/changePassword', icon: icon('ic_lock') },
    ],
  },
];

export default navConfig;
